import React from 'react';
import { useSelector } from 'react-redux';
import { useContentGate } from '../../hooks/useContentGate';
import { UserGated, UserCabinedMode, RedeemError } from '../Access';
import { GuardianInfoForm } from '../legal/GuardianInfoForm';
import { InvalidGuardianInfo } from './InvalidGuardianInfo';
import { selectdateOfBirthIntegrity } from '../../selectors/account.selector';

interface ContentGateProps {
    gameId: string;
    children: React.ReactNode;
}

export const ContentGate: React.FC<ContentGateProps> = ({ gameId, children }) => {
    const {
        isLoggedIn,
        showEntitlementError,
        showContentGated,
        showCabinedMode,
        showLegalContent,
        gatedAge
    } = useContentGate(gameId);
    const dateOfBirthIntegrity = useSelector(selectdateOfBirthIntegrity);

    if (!isLoggedIn) {
        return null;
    }

    if (showEntitlementError) {
        return <RedeemError />;
    }

    if (showContentGated) {
        return <UserGated age={gatedAge} />;
    }

    if (showCabinedMode) {
        return <UserCabinedMode />;
    }

    if (showLegalContent) {
        if (dateOfBirthIntegrity?.guardianEmail) {
            return <GuardianInfoForm guardianEmail={dateOfBirthIntegrity?.guardianEmail} />;
        } else {
            return <InvalidGuardianInfo />;
        }
    }

    return <>{children}</>;
};
